/**
 * Calculates table height accounting for zoom level
 * @param zoomLevel - The current zoom level (typically from useZoom hook)
 * @param offset - The offset in pixels to subtract from the viewport height (default: 200)
 * @returns A CSS height string (e.g., "800px" or "calc(100vh - 200px)")
 */
const calculateTableHeight = (zoomLevel: number, offset: number = 200): string => {
  if (globalThis.window) {
    const viewportHeight = globalThis.window.innerHeight;
    const adjustedHeight = viewportHeight / zoomLevel;
    return `${adjustedHeight - offset}px`;
  }
  return `calc(100vh - ${offset}px)`;
};

export { calculateTableHeight };
